import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Users,
  Car,
  Activity,
  Bell,
  CreditCard,
  LogOut,
  ChevronLeft,
  ChevronRight,
} from 'lucide-react'
import { useAdminAuth } from '../hooks/useAdminAuth.js'
import CarFileLogo from './CarFileLogo.jsx'

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/users', icon: Users, label: 'Users' },
  { to: '/vehicles', icon: Car, label: 'Vehicles' },
  { to: '/subscriptions', icon: CreditCard, label: 'Subscriptions' },
  { to: '/notifications', icon: Bell, label: 'Notifications' },
  { to: '/system', icon: Activity, label: 'System Health' },
]

const Sidebar = ({ collapsed, setCollapsed }) => {
  const { logout, user } = useAdminAuth()

  return (
    <aside
      className={`fixed top-0 left-0 h-screen bg-gray-950 text-white flex flex-col transition-all duration-300 z-40 ${
        collapsed ? 'w-20' : 'w-64'
      }`}
    >
      {/* Logo */}
      <div className="flex items-center justify-center px-5 py-6 border-b border-white/10">
        <CarFileLogo size={collapsed ? 'sm' : 'lg'} dark />
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-4 space-y-1 px-3">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-3 rounded-xl transition-all duration-200 group ${
                isActive
                  ? 'bg-gradient-to-r from-blue-500/20 to-purple-500/20 text-blue-400'
                  : 'text-gray-400 hover:text-white hover:bg-white/5'
              }`
            }
          >
            <item.icon className="w-5 h-5 shrink-0" aria-hidden="true" />
            {!collapsed ? <span className="font-medium">{item.label}</span> : <span className="sr-only">{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* User / Logout */}
      <div className="border-t border-white/10 p-4 space-y-3">
        {!collapsed && user && (
          <div className="text-sm text-gray-400 truncate px-1">{user.email}</div>
        )}
        <button
          onClick={logout}
          className="flex items-center gap-3 px-3 py-2 rounded-xl text-gray-400 hover:text-red-400 hover:bg-red-500/10 transition-all w-full"
          aria-label="Logout"
        >
          <LogOut className="w-5 h-5 shrink-0" aria-hidden="true" />
          {!collapsed && <span className="font-medium">Logout</span>}
        </button>
      </div>

      {/* Collapse toggle */}
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="absolute -right-3 top-20 w-6 h-6 bg-gray-800 border border-gray-700 rounded-full flex items-center justify-center text-gray-400 hover:text-white hover:bg-gray-700 transition-colors"
        aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {collapsed ? <ChevronRight className="w-3 h-3" /> : <ChevronLeft className="w-3 h-3" />}
      </button>
    </aside>
  )
}

export default Sidebar
